/* unplugin-vue-components disabled */import { render } from "./Live.vue?vue&type=template&id=52c47bce&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=52c47bce&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c47bce"]])

export default __exports__